const config = {
	assets: {
		epBroken: 'assets/letters/ep-broken.gltf',
		scene: 'assets/scene2.gltf',
	},
}
export default config